
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FaceVerifyToast extends Vue {
  showToast(message: string) {
    const toast = this.$refs.toast as HTMLElement;
    (this.$refs.toastMessage as HTMLElement).textContent = message;
    toast.style.visibility = "visible";

    setTimeout(() => {
      toast.style.visibility = "hidden";
    }, 2000);
  }
}
